export const truncateText = (text = '', maxLength = 30) =>
  text.length > maxLength ? (
    <span title={text}>{text.slice(0, maxLength)}...</span>
  ) : (
    text
  );
